import React, { Component } from 'react';
import styled from "react-emotion";
import { Link } from 'gatsby';
// import kebabCase from 'lodash/kebabCase';
import Img from 'gatsby-image';

const StyledSolutionBox = styled.div`
    width: 30%;
    padding-top: 15%;
    margin: 0.5rem;
    background-size: cover;
    background-position: left bottom;
    @media (max-width: ${props => props.theme.breakpoints.m}) {
        width: 45%;
        padding-top: 20%;
    }
    @media (max-width: ${props => props.theme.breakpoints.s}) {
        width: 100%;
        padding-top: 44%;
    }
    background-color: ${props => props.backgroundColor};
    position: relative;
    text-align: center;
    &:hover {
        .solution-description {
            opacity: 1;
            visibility: visible;
            top: 0rem;
        }
        .solution-icon {
            opacity: 1;
            visibility: visible;
            bottom: 0rem;
        }
        .solution-title {
            opacity: 0;
            visibility: none;
            bottom: -1rem;
        }
    }
`;

const StyledSolution = styled.div`
    text-align: start;
    padding-left: 1rem;
    bottom: 0px;
`;

const SolutionTitle = styled.p`
    position: absolute;
    bottom: 0rem;
    margin-bottom: 1rem;
    opacity: 1;
    visibility: visible;
    transition: opacity 300ms, visibility 300ms, bottom 300ms;
`;

const SolutionDescription = styled.p`
    position: absolute;
    height: 80%;
    top: -1rem;
    left: 0rem;
    margin: 0.75rem;
    visibility: hidden;
    opacity: 0;
    transition: opacity 300ms, visibility 300ms, top 300ms;
    font-size: 0.8rem;
`;

const SolutionIcon = styled.div`
    textAlign: right;
    position: absolute;
    right: 0;
    bottom: 1rem;
    margin: 0.75rem;
    visibility: hidden;
    opacity: 0;
    transition: opacity 300ms, visibility 300ms, bottom 300ms;
    font-size: 0.8rem;
`;

const StyledLink = styled(props => <Link {...props} />)`
  font-style: normal;
  color: ${props => props.theme.colors.black};
  font-weight: 400;
`;

class Solution extends Component {
    render() {
        const { serviceName, color, backgroundImage, categoryDescription, category_icon } = this.props
        return (
            <StyledSolutionBox style={{ backgroundImage: 'url(' + backgroundImage.localFile.childImageSharp.fluid.src + ')' }}>
                <StyledSolution>
                    {/* <StyledLink to={`/project-categories/${kebabCase(serviceName)}`}> */}
                    <SolutionDescription className='solution-description'>
                        {categoryDescription}
                    </SolutionDescription>
                    <SolutionIcon className='solution-icon'>
                        <Img fluid={category_icon.localFile.childImageSharp.fluid} style={{ width: '40px' }} />
                    </SolutionIcon>
                    {/* </StyledLink> */}
                    {/* <StyledLink to={`/project-categories/${kebabCase(serviceName)}`}> */}
                    <SolutionTitle className='solution-title'>{serviceName}</SolutionTitle>
                    {/* </StyledLink> */}
                </StyledSolution>
            </StyledSolutionBox>
        );
    }
}

export default Solution;